import { useEffect, useState, Fragment, useRef } from 'react';
import { Dialog, Transition } from '@headlessui/react';
// import { useRouter } from 'next/router';
import ErrorMessage from "components/form/ErrorMessage"
import SuccessMessage from "components/form/SuccessMessage"
import Button from 'components/form/Button';
import {
  SimpleTextInput,
  SelectInput,
  InputDate,
  LinkInput,
  TimeInput,
  RadioLink,
  MultipleLinkInput,
  TextareaInput
} from 'components/form/FormOeuvre';
import classNames from 'classnames';
import CloseModal from "components/form/CloseModal";
import axios from 'lib/axios'
import 'react-loading-skeleton/dist/skeleton.css'
// import { useAuth } from '@/../hooks/auth'
import Loader from "components/ui/Loader"
import { useCookies } from 'react-cookie'
import { PIANO_AUTH_CRED  } from "lib/constants"

const optionMethod = [
  { value: "Piece", label: 'Piece' },
  { value: "Compilation", label: 'Compilation' },
  { value: "Method", label: 'Method' }
];

const optionType = [
  { value: "3 pianos 6 mains", label: '3 pianos 6 mains' },
  { value: "2 pianos 4 hands", label: '2 pianos 4 hands' },
  { value: "1 piano 4 hands", label: '1 piano 4 hands' },
  { value: "2 pianos 4 hands + instruments (less than 9 instruments)", label: '2 pianos 4 hands + instruments (less than 9 instruments)' },
  { value: "1 piano 4 hands + instruments", label: '1 piano 4 hands + instruments' },
  { value: "2 pianos 4 hands + orchestra", label: '2 pianos 4 hands + orchestra' },
  { value: "1 piano 4 hands + orchestra - specific instruments", label: '1 piano 4 hands + orchestra - specific instruments' }
];

const optionLevel = [
  { value: "Beginner", label: 'Beginner' },
  { value: "Intermediate", label: 'Intermediate' },
  { value: "Advanced", label: 'Advanced' }
];

const optionOriginal = [
  { value: "Original work", label: 'Original work' },
  { value: "Transcription", label: 'Transcription' }
];

export default function EditOeuvreModal({
  open,
  oeuvreToEdit,
  setOpen
}) {

  const [cookie, setCookie, removeCookie] = useCookies([PIANO_AUTH_CRED]);

  const selectMethod = useRef(null);
  const selectType = useRef(null);
  const selectLevel = useRef(null);
  const selectComposer = useRef(null);
  const selectOriginal = useRef(null);

  // User infos
  // const {user} = useAuth();
  // const router = useRouter();

  // Help state
  const [fieldHelp, setFieldHelp] = useState("");

  const [allowed, setAllowed] = useState(false),
    [errorNotAllowed, setErrorNotAllowed] = useState(null),
    [optionComposer, setOptionComposer] = useState([]),
    [dataOeuvre, setDataOeuvre] = useState({});

  // handling statelinkToHear
  const [isLoading, setIsLoading] = useState(false),
    [errors, setErrorsMessage] = useState(''),
    [success, setSuccessMessage] = useState(''),
    [isSubmitted, setIsSubmitted] = useState(false);


  const checkIfAlreadySubmit = async (id) => {

    let payload = {
      oeuvre_id: id
    }

    await axios.post('/check-oeuvre', payload, {
      headers: { 'Authorization': `Bearer ${cookie?.auth_piano}` }
    }).then(res => {
      // if (res.data.status == false) {
      //   setErrorNotAllowed(res.data.message);
      //   setAllowed(true);
      // } else {
      //   setErrorNotAllowed(null);
      //   setAllowed(false);
      // }
    }).catch((err) => {
      console.log("error", err.response)
    })

  }

  const getAllComposer = async () => {
    await axios.get('/display-all-composers', {
      headers: { 'Authorization': `Bearer ${cookie?.auth_piano}` }
    }).then(res => {
      const { data } = res.data;
      setOptionComposer(data)
    }).catch((err) => {
      //console.log("error composer", err.response)
    })
  }

  useEffect(() => {
    if (!open) {
      setDataOeuvre({});
    } else {
      checkIfAlreadySubmit(oeuvreToEdit?.id);
      setDataOeuvre(oeuvreToEdit);
    }
  }, [open]);

  useEffect(() => {
    getAllComposer();
  }, []);

  // Submit oeuvre forms
  const submitFormOeuvre = () => {

    setIsSubmitted(true);

    setSuccessMessage(null);

    setErrorsMessage([]);

    setIsLoading(true);

    let newOeuvre = { ...dataOeuvre, oeuvre_id: dataOeuvre.id }

    console.log("newOeuvre", newOeuvre);

    axios.post(`/submitting-oeuvre`, newOeuvre, {
      headers: { 'Authorization': `Bearer ${cookie?.auth_piano}` }
    }).then(res => {
      if (res.status == 200) {
        setIsLoading(false);
        setIsSubmitted(false);
        setSuccessMessage("Created successfuly !. You will be redirecting in your account");

        setTimeout(() => {
          setOpen(false);
          //window.location.pathname = "/oppdb/app/work";
          setSuccessMessage(null);
        }, 3000);
      }
    }).catch((error) => {
      setIsLoading(false);
      setErrorsMessage(Object.values(error.response.data.errors ||{}).flat())
      console.log("error oeuvres", error.response);
      // if(err.response){
      //   setErrorsMessage(" Something went wrong !!! ")
      // }
    })
  }

  const cancelButtonRef = useRef();

  const addNewLinkToScore = (event) => {
    if (event.key === "Enter" && event.target.value !== "") {
      if (dataOeuvre.linkToScores == null) {
        setDataOeuvre({ ...dataOeuvre, linkToScores: [] });
      }
      setDataOeuvre({ ...dataOeuvre, linkToScores: [...dataOeuvre.linkToScores, event.target.value] });
      event.target.value = "";
    }
  };

  const addNewLinkToHear = event => {
    if (dataOeuvre.linkToHears == null) {
      setDataOeuvre({ ...dataOeuvre, linkToHears: [] });
    }
    if (event.key === "Enter" && event.target.value !== "") {
      setDataOeuvre({ ...dataOeuvre, linkToHears: [...dataOeuvre.linkToHears, event.target.value] });
      event.target.value = "";
    }
  };

  const addNewLinkToBuys = event => {
    if (dataOeuvre.linkToBuys == null) {
      setDataOeuvre({ ...dataOeuvre, linkToBuys: [] });
    }
    if (event.key === "Enter" && event.target.value !== "") {
      setDataOeuvre({ ...dataOeuvre, linkToBuys: [...dataOeuvre.linkToBuys, event.target.value] });
      event.target.value = "";
    }
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-50 inset-0 overflow-y-auto"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <div className="flex items-start justify-start h-screen">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="
              inline-block align-bottom
              overflow-hidden shadow-xl 
              transform transition-all 
              h-full w-full"
            >
              <div className="h-full w-full bg-gray-100 overflow-y-auto pb-16">
                <CloseModal onClick={() => setOpen(false)} />

                <div className="flex flex-col justify-center items-center py-4">
                  <h2 className="mb-2 text-3xl text-center font-bold text-gray-800">Edit this card </h2>
                  <p className="text-gray-600">Propose a modification of this card </p>
                </div>

                <div className="w-full px-4 md:px-8 lg:px-20 xl:px-40 mb-24">

                  <i className="block flex flex-col items-start text-xs text-red-500"> The fields with * are required </i>
                  <div className="rounded bg-white shadow-xl p-8 space-y-6 mt-6">

                    {errorNotAllowed && <p className="text-center text-sm md:text-lg text-red-500">{errorNotAllowed} </p>}

                    {/* Title */}
                    <SimpleTextInput
                      fieldName={"Title"}
                      value={dataOeuvre?.title}
                      onChange={(e) => setDataOeuvre({ ...dataOeuvre, title: e.target.value })}
                      isSubmitted={isSubmitted}
                      isRequired={true}
                      readOnly={allowed}
                    />

                    {/* Method */}
                    <SelectInput
                      value={dataOeuvre?.typeOfCard}
                      options={optionMethod}
                      placeholder="Select type of card"
                      fieldName={"Type of card"}
                      myRef={selectMethod}
                      defaultValue={dataOeuvre?.typeOfCard}
                      onChange={(e) => setDataOeuvre({ ...dataOeuvre, typeOfCard: e?.value })}
                      isSubmitted={isSubmitted}
                      isRequired={true}
                      readOnly={allowed}
                    />

                    {/* Publisher */}
                    <SimpleTextInput
                      fieldName={"Publisher"}
                      value={dataOeuvre?.publisher}
                      onChange={(e) => setDataOeuvre({ ...dataOeuvre, publisher: e.target.value })}
                      isSubmitted={isSubmitted}
                      isRequired={true}
                      readOnly={allowed}
                    />

                    {/* Type */}
                    <SelectInput
                      value={dataOeuvre?.typeChoosen}
                      fieldName={"Formation type"}
                      options={optionType}
                      placeholder="Select the type"
                      myRef={selectType}
                      defaultValue={dataOeuvre?.typeChoosen}
                      onChange={(e) => setDataOeuvre({ ...dataOeuvre, typeChoosen: e?.value })}
                      isSubmitted={isSubmitted}
                      isRequired={true}
                      readOnly={allowed}
                    />

                    {/* PublicationDate */}
                    <InputDate
                      value={dataOeuvre?.dateOfPublication}
                      fieldName="Date of first publication"
                      onChange={(e) => setDataOeuvre({ ...dataOeuvre, dateOfPublication: e.target.value })}
                      isSubmitted={isSubmitted}
                      readOnly={allowed}
                    />

                    {/* Publisher reference */}
                    <SimpleTextInput
                      fieldName={"Publisher reference"}
                      onClick={() => setFieldHelp('publisherRef')}
                      help={fieldHelp == "publisherRef" ? true : false}
                      showHelp={true}
                      textHelp="Write here the reference of the score according to the publisher. For example, En Blanc et Noir published by Durand & Fils : D&F 15854"
                      value={dataOeuvre?.publisherRef}
                      onChange={(e) => setDataOeuvre({ ...dataOeuvre, publisherRef: e.target.value })}
                      isSubmitted={isSubmitted}
                      readOnly={allowed}
                    />

                    {/* Display here only if methode is compilation */}
                    {dataOeuvre.typeOfCard == "Compilation" &&
                      /* Arranger name */
                      <SimpleTextInput
                        fieldName={"Arranger name"}
                        value={dataOeuvre?.arrangeurName}
                        onChange={(e) => setDataOeuvre({ ...dataOeuvre, arrangeurName: e.target.value })}
                        isSubmitted={isSubmitted}
                        readOnly={allowed}
                      />
                    }

                    {/* Content */}
                    {/* <SimpleTextInput  */}
                    <TextareaInput
                      fieldName={"Content"}
                      value={dataOeuvre?.content}
                      onChange={(e) => setDataOeuvre({ ...dataOeuvre, content: e.target.value })}
                      isSubmitted={isSubmitted}
                      readOnly={allowed}
                    />

                    {/* Level */}
                    <SelectInput
                      value={dataOeuvre.level}
                      options={optionLevel}
                      placeholder="Select level"
                      myRef={selectLevel}
                      fieldName={"Level"}
                      defaultValue={dataOeuvre?.level}
                      onChange={(e) => setDataOeuvre({ ...dataOeuvre, level: e?.value })}
                      isSubmitted={isSubmitted}
                      readOnly={allowed}
                    />

                    {/* Composer name */}
                    <SelectInput
                      value={dataOeuvre?.composer_id}
                      options={optionComposer}
                      fieldName={dataOeuvre?.cpm_firstName? "Composer name " +  ' - actual : ' + dataOeuvre?.cpm_firstName + ' ' + dataOeuvre?.cpm_lastName : "Composesr name "}
                      placeholder="Select name of composer"
                      // defaultData={dataOeuvre?.firstName + ' ' + dataOeuvre?.lastName}
                      getOptionLabel={option => `${option.firstName + ' ' + option.lastName}`}
                      getOptionValue={option => `${option.id}`}
                      myRef={selectComposer}
                      onChange={(e) => setDataOeuvre({ ...dataOeuvre, composer_id: e?.id })}
                      isSubmitted={isSubmitted}
                      isRequired={dataOeuvre?.typeOfCard?.toLowerCase() === "piece" ? true : false}
                      readOnly={allowed}
                    />

                    {/* Collection name */}
                    <SimpleTextInput
                      fieldName={"Collection name"}
                      value={dataOeuvre.collectionName}
                      onChange={(e) => setDataOeuvre({ ...dataOeuvre, collectionName: e.target.value })}
                      isSubmitted={isSubmitted}
                      readOnly={allowed}
                    />

                    {/* Mouvement */}
                    <TextareaInput
                      fieldName={"Movement"}
                      onClick={() => setFieldHelp('movement')}
                      help={fieldHelp == "movement" ? true : false}
                      showHelp={true}
                      textHelp="List here the different movements of the work, or the different pieces of a collection. Respect the following presentation:
                      1.
                      2.
                      etc."
                      value={dataOeuvre.mouvement}
                      onChange={(e) => setDataOeuvre({ ...dataOeuvre, mouvement: e.target.value })}
                      isSubmitted={isSubmitted}
                      readOnly={allowed}
                    />

                    {/* Date of composition */}
                    <InputDate
                      value={dataOeuvre.dateOfComposition}
                      fieldName="Date of composition"
                      onChange={(e) => setDataOeuvre({ ...dataOeuvre, dateOfComposition: e.target.value })}
                      isSubmitted={isSubmitted}
                      isRequired={false}
                      readOnly={allowed}
                    />

                    {/* Original or transcription */}
                    <SelectInput
                      fieldName={"Original or transcription"}
                      placeholder="Select here..."
                      myRef={selectOriginal}
                      options={optionOriginal}
                      value={dataOeuvre?.originalTranscription}
                      defaultValue={dataOeuvre?.originalTranscription}
                      onChange={(e) => setDataOeuvre({ ...dataOeuvre, originalTranscription: e?.value })}
                      isSubmitted={isSubmitted}
                      isRequired={true}
                      readOnly={allowed}
                    />

                    {dataOeuvre?.originalTranscription?.toLowerCase() === "transcription" &&
                      /* Transcription name */
                      <SimpleTextInput
                        fieldName={"Transcriptor name"}
                        value={dataOeuvre?.transcriptorName}
                        onChange={(e) => setDataOeuvre({ ...dataOeuvre, transcriptorName: e.target.value })}
                        isSubmitted={isSubmitted}
                        readOnly={allowed}
                      />
                    }

                    {/* Instrument */}
                    <SimpleTextInput
                      fieldName={"Instruments"}
                      onClick={() => setFieldHelp('instrument')}
                      help={fieldHelp == "instrument" ? true : false}
                      showHelp={true}
                      textHelp="In the case of ensemble music for piano duet with other instruments, list the instruments here, separated by a comma."
                      value={dataOeuvre?.instrument}
                      onChange={(e) => setDataOeuvre({ ...dataOeuvre, instrument: e.target.value })}
                      isSubmitted={isSubmitted}
                      readOnly={allowed}
                    />

                    {/* Duration */}
                    <TimeInput
                      fieldName={"Duration"}
                      onClick={() => setFieldHelp('duration')}
                      help={fieldHelp == "duration" ? true : false}
                      showHelp={true}
                      textHelp="Enter here the average duration of the work"
                      value={dataOeuvre?.duration}
                      onChange={(e) => setDataOeuvre({ ...dataOeuvre, duration: e.target.value })}
                      isSubmitted={isSubmitted}
                      readOnly={allowed}
                    />

                    {/* First performance */}
                    <SimpleTextInput
                      fieldName={"First performance"}
                      onClick={() => setFieldHelp('firstPerformance')}
                      help={fieldHelp == "firstPerformance" ? true : false}
                      showHelp={true}
                      textHelp="Enter here the names of the first performers and the date of creation (DD/MM/YYYY or YYYY)"
                      value={dataOeuvre?.firstPerformance}
                      onChange={(e) => setDataOeuvre({ ...dataOeuvre, firstPerformance: e.target.value })}
                      isSubmitted={isSubmitted}
                      readOnly={allowed}
                    />

                    {/* Nomenclature */}
                    <TextareaInput
                      fieldName={"Nomenclature"}
                      onClick={() => setFieldHelp('nomenclature')}
                      help={fieldHelp == "nomenclature" ? true : false}
                      showHelp={true}
                      textHelp="Orchestra instrumentation for a concerto. Please use the following notation type: 
                      3223 / 2230 / timp.perc / str
                      4(2pic)4(ca)4(bcl)3(cbn) / 7431 / 2timp.perc / hp / str
                      (examples according to the usual conventions)"
                      value={dataOeuvre?.nomenclature}
                      onChange={(e) => setDataOeuvre({ ...dataOeuvre, nomenclature: e.target.value })}
                      isSubmitted={isSubmitted}
                      readOnly={allowed}
                    />

                    {/* Link to score */}
                    <MultipleLinkInput
                      fieldName={"Link to scores"}
                      onKeyUp={event => event.key === "Enter" ? addNewLinkToScore(event) : null}
                      onClick={() => setFieldHelp('linkToScores')}
                      help={fieldHelp == "linkToScores" ? true : false}
                      showHelp={true}
                      showAlert={true}
                      textHelp="Copy here the url to a merchant site offering the score. If the score is not or no longer published, or if it is in the public domain, copy here the url to a page allowing to download the score legally."
                      isSubmitted={isSubmitted}
                    >
                      {Array.isArray(dataOeuvre?.linkToScores) && dataOeuvre.linkToScores.map((item, index) => (
                        <li key={index} className="tag">
                          <span className='tag-title'>{item}</span>
                          <span className='tag-close-icon'
                            onClick={() => setDataOeuvre({
                              ...dataOeuvre,
                              linkToScores: [...dataOeuvre.linkToScores.filter(link => dataOeuvre.linkToScores.indexOf(link) !== index)]
                            })
                            }
                          >x</span>
                        </li>
                      ))}
                    </MultipleLinkInput>

                    {/* Link to hear */}
                    <MultipleLinkInput
                      fieldName={"Link to hear"}
                      onKeyUp={event => event.key === "Enter" ? addNewLinkToHear(event) : null}
                      onClick={() => setFieldHelp('linkToHears')}
                      help={fieldHelp == "linkToHears" ? true : false}
                      showHelp={true}
                      showAlert={true}
                      textHelp="Copy here the url of a playlist made on a streaming platform offering one or several recorded versions of the work. Create your own playlist on the platforms you use and share them here."
                      isSubmitted={isSubmitted}
                    >
                      {Array.isArray(dataOeuvre?.linkToHears) && dataOeuvre.linkToHears.map((item, index) => (
                        <li key={index} className="tag">
                          <span className='tag-title'>{item}</span>
                          <span className='tag-close-icon'
                            onClick={() => setDataOeuvre({
                              ...dataOeuvre,
                              linkToHears: [...dataOeuvre.linkToHears.filter(link => dataOeuvre.linkToHears.indexOf(link) !== index)]
                            })
                            }
                          >x</span>
                        </li>
                      ))}
                    </MultipleLinkInput>

                    {/* Link to buy */}
                    <MultipleLinkInput
                      fieldName={"Link to CD"}
                      onKeyUp={event => event.key === "Enter" ? addNewLinkToBuys(event) : null}
                      onClick={() => setFieldHelp('linkToBuys')}
                      help={fieldHelp == "linkToBuys" ? true : false}
                      showHelp={true}
                      showAlert={true}
                      textHelp="Copy here the url of a site offering a commercial recording of the work on physical support"
                      isSubmitted={isSubmitted}
                    >
                      {Array.isArray(dataOeuvre?.linkToBuys) && dataOeuvre.linkToBuys.map((item, index) => (
                        <li key={index} className="tag">
                          <span className='tag-title'>{item}</span>
                          <span className='tag-close-icon'
                            onClick={() => setDataOeuvre({
                              ...dataOeuvre,
                              linkToBuys: [...dataOeuvre.linkToBuys.filter(link => dataOeuvre.linkToBuys.indexOf(link) !== index)]
                            })
                            }
                          >x</span>
                        </li>
                      ))}
                    </MultipleLinkInput>

                    {/* Rungis Festival Link */}
                    <RadioLink
                      value={dataOeuvre.rungisFestivallinks}
                      fieldName={"Performed at the Rungis Piano-Piano Festival"}
                      onChange={(e) => setDataOeuvre({ ...dataOeuvre, rungisFestivallinks: e.target.value })}
                      isSubmitted={isSubmitted}
                      readOnly={allowed}
                    />

                    {/* Notes */}
                    <TextareaInput
                      fieldName={"Notes"}
                      value={dataOeuvre?.notes}
                      onChange={(e) => setDataOeuvre({ ...dataOeuvre, notes: e.target.value })}
                      isSubmitted={isSubmitted}
                      readOnly={allowed}
                    />

                    <ErrorMessage errors={errors} />
                    <SuccessMessage success={success} handleHideMsg={() => setSuccessMessage('')} />

                    {/* Action */}
                    <div className="flex flex-col py-4 items-end">
                      <Button
                        disabled={isLoading || allowed}
                        onClick={() => submitFormOeuvre()}
                        className={classNames(
                          !isLoading ? '' : 'bg-gray-500 opacity-50 cursor-not-allowed',
                          !allowed ? '' : 'bg-gray-500 opacity-50 cursor-not-allowed',
                          ""
                        )}
                      >
                        {!isLoading ? 'Update' :
                          <> <Loader /> <span className="mr-1"></span> Updating... </>
                        }
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
